import contacts from './data'
import './contact.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useState, useEffect } from 'react';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const listener = (event) => setMatches(event.matches);

    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [query]);

  return matches;
}

const Contact = () => {
  useEffect(() => {
    AOS.init({duration: 2000})
  }, [])
  const isTabletOrSmaller = useMediaQuery('(max-width: 600px)');
  
  return (
    <section id="contact">
      <h2 data-aos={isTabletOrSmaller ? undefined : "fade-up"}>Get In Touch</h2>
      <p data-aos={isTabletOrSmaller ? undefined : "fade-up"}>
        Send me a message via any of the links below!
      </p>
      <div className="container contact__container" data-aos={isTabletOrSmaller ? undefined : "fade-up"}>
        {
          contacts.map(contact => <a key={contact.id} href={contact.link} target="_blank" rel="noopener noreferrer">{contact.icon}</a>)
        }
      </div>
    </section>
  )
}

export default Contact